export default __webpack_public_path__ + "static/media/home-klaus.a72b301e.jpg";